import { render, staticRenderFns } from "./ModalAddSeriesReal.vue?vue&type=template&id=03d0a286&scoped=true&"
import script from "./ModalAddSeriesReal.vue?vue&type=script&lang=js&"
export * from "./ModalAddSeriesReal.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddSeriesReal.vue?vue&type=style&index=0&id=03d0a286&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d0a286",
  null
  
)

export default component.exports